import { useSelector } from "react-redux";
import { Link, useLocation, useParams } from 'react-router-dom';
import { Loading } from '../../components/Loading';
import ErrorMessageBox from '../../components/ErrorMessageBox';
import { useQuery } from "@tanstack/react-query";
import Api, { createFetchErrorMessage } from 'utils/api/Api';

export const UserBookReady = ()=>{
    const location = useLocation();
    const { school, book } = useParams();
    const auth = useSelector(state => state.auth);
    
    const { data:userBook, isLoading, isError, error } = useQuery({
        queryKey:['userbook', book],
        queryFn:()=>Api.get(`/api/userBook/${book}`),
    });


    if (isLoading) return <Loading />
    if (isError){
        return <ErrorMessageBox message={createFetchErrorMessage(error).message}
                                        goto={<Link className="btn _border" to={`/${school}/userbook${location.search}`} >목록</Link>} />;
    }

    if( userBook.data?.userId!==auth.id ){
        return <ErrorMessageBox message="권한이 없는 작품 입니다." goto={<Link className="btn _border" to={`/${school}/userbook${location.search}`} >목록</Link>} />;            
    }
    
    return (
        <div className="userBookCreate">
            <div className="step inner userBookReady">
                <div className="row">
                    <div className="col6 col-md-12 bookgomi">
                        <img src={`${process.env.PUBLIC_URL}/static/images/userbook/new_userbook_complete_bookgomi.gif`} alt=""/>
                    </div>

                    <div className="col6 col-md-12 ">
                        <div className="guideBox">
                            <h3 className="title">
                                "{userBook.data?.subject}"
                                <small>작품이 준비되었습니다!</small>
                            </h3>
                            <p>작품 활동을 시작해보아요~</p>

                            <div className="controls">
                                <Link className="btn _blue" to={`/${school}/userbook/cover/${book}`}><img src={`${process.env.PUBLIC_URL}/static/images/userbook/userbook_ready_painting.png`} alt=""/></Link>
                                <Link className="btn _red" to={`/${school}/userbook/episode/create/${book}`}><img src={`${process.env.PUBLIC_URL}/static/images/userbook/userbook_ready_writing.png`} alt=""/></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};